import styled from 'styled-components'

import { ThemeModeType } from '@application/Types/ComponentTypes'
import { Link } from '@src/Application/Interfaces/Atoms/Link'

export const Title = styled.h3`
    ${(props) => props.theme.typo.bodyL};
    ${(props) => props.theme.fontWeight.medium};
    margin-bottom: 20px;

    @media ${(props) => props.theme.query.min.tablet} {
        ${(props) => props.theme.typo.displayM};
    }
`

export const Description = styled.p`
    ${(props) => props.theme.typo.bodyM};
    ${(props) => props.theme.fontWeight.regular};
    margin-bottom: 30px;
    text-align: justify;

    @media ${(props) => props.theme.query.min.tablet} {
        ${(props) => props.theme.typo.bodyL};
    }
`
export const GetStarted = styled(Link)`
    display: inline-block;
    padding: 14px 16px;
    border-radius: 3px;
    border: 2px solid ${(props) => props.theme.color.p500};
    ${(props) => props.theme.typo.bodyM};
    ${(props) => props.theme.fontWeight.medium};
    color: ${(props) => props.theme.color.p500};
    background-color: ${(props) => props.theme.color.white};
    text-decoration: none;
    width: 100%;
    text-align: center;
    text-transform: uppercase;

    @media ${(props) => props.theme.query.min.tablet} {
        width: auto;
    }

    span {
        margin-right: 8px;
    }

    &:hover {
        color: ${(props) => props.theme.color.white};
        background-color: ${(props) => props.theme.color.p500};

        svg path {
            fill: ${(props) => props.theme.color.white};
            stroke: ${(props) => props.theme.color.white};
        }
    }
`

export const Wrapper = styled.div<{ $mode: ThemeModeType }>`
    ${Title} {
        color: ${(props) => props.theme.color[props.$mode === 'Light' ? 'black' : 'white']};
    }

    ${Description} {
        color: ${(props) => props.theme.color[props.$mode === 'Light' ? 'g500' : 'g100']};
    }
`
